import React, { useEffect, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";

const Signature = (props) => {
    const { setDateData, setSignatureData, day, month, year } = props;
    const signatureRef = useRef(null);
    const dayRef = useRef(null);
    const monthRef = useRef(null);
    const yearRef = useRef(null);

    useEffect(() => {
        if (props.signature === "" && signatureRef.current) {
          signatureRef.current.clear();
        }
    }, [props.signature]);

    const clearSignature = () => {
        signatureRef.current.clear();
        setSignatureData("");
    };

    const handleEnd = () => {
        const canvas = signatureRef.current.getCanvas();
        const ctx = canvas.getContext('2d');
        ctx.willReadFrequently = true;

        const imageData = signatureRef.current.getTrimmedCanvas().toDataURL("image/png");
        setSignatureData(imageData);
    };

    const onDateChange = (e) => {
        let data = e.target.value;
        if (isNaN(Number(data))) {
          return;
        }
        setDateData({ name: e.target.name, value: data });
    };

    return (
        <div className="container mt-4">
            <div className="row mt-4">
                <div className="col-md-12">
                    <div className="form-group row">
                        <label htmlFor="signature" className="col-sm-2 col-form-label">Your signature:</label>
                        <div className="col-sm-4">
                            <div className="digital-signed">
                                <div className="name" style={{ width: "100%", borderWidth: '1px', borderStyle: 'solid', borderColor: '#eee' }}>
                                    <SignatureCanvas
                                        penColor="black"
                                        backgroundColor="white"
                                        ref={signatureRef}
                                        onEnd={handleEnd}
                                    />
                                </div>
                            </div>
                            <button className="clear-signature-irr3" onClick={clearSignature} style={{ cursor: "pointer" }}>
                                Clear signature
                            </button>
                        </div>
                        <label htmlFor="date" className="col-sm-1 col-form-label text-right">Date:</label>
                        <div className="col-sm-3">
                            <div className="form-inline">
                                <input type="text" id="day" name="day" maxLength={2} className="form-control" placeholder="DD" ref={dayRef} value={day} onChange={onDateChange} style={{ width: '60px' }} required />
                                <input type="text" id="month" name="month" maxLength={2} className="form-control" placeholder="MM" ref={monthRef} value={month} onChange={onDateChange} style={{ width: '60px' }} required />
                                <input type="text" id="year" name="year" maxLength={4} className="form-control" placeholder="YYYY" ref={yearRef} value={year} onChange={onDateChange} style={{ width: '80px' }} required />
                            </div>
                        </div>
                    </div>
                    <div className="form-group row">
                    </div>
                </div>
            </div>
        </div>
    );
};

    
export default Signature;